"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpointKeys = exports.spacingKeys = exports.typographyKeys = exports.buttonTypeKeys = exports.alertPaletteKeys = exports.fontPaletteKeys = void 0;
exports.fontPaletteKeys = ['base', 'secondary', 'disabled', 'inverse', 'success', 'link', 'linkHover'];
exports.alertPaletteKeys = ['success', 'information', 'warning', 'error'];
exports.buttonTypeKeys = ['buyNow', 'primary'];
exports.typographyKeys = [
    'micro',
    'mini',
    'small',
    'base',
    'basePlus',
    'medium',
    'mediumPlus',
    'large',
    'extraLarge',
    'doubleLarge'
];
exports.spacingKeys = [
    'micro',
    'mini',
    'small',
    'base',
    'medium',
    'mediumPlus',
    'large',
    'extraLarge',
    'extraLargePlus',
    'doubleLarge'
];
exports.breakpointKeys = ['xs', 'sm', 'md', 'lg', 'xl'];
